/* ==========================================================
   NORDAUS JOURNAL LIGHTBOX
   Part 1 - Initialization & Gallery
   ========================================================== */

(() => {
  'use strict';

  const SELECTORS = {
    trigger: '.nd-journal__lightbox-trigger',
    image: '.nd-journal__media',
    lightbox: '#ndJournalLightbox',
    lightboxImage: '.nd-lightbox__image',
    close: '.nd-lightbox__close',
    prev: '.nd-lightbox__prev',
    next: '.nd-lightbox__next',
    current: '.nd-current',
    total: '.nd-total'
  };

  let gallery = [];
  let currentIndex = 0;

  let lightbox;
  let lightboxImage;
  let closeButton;
  let prevButton;
  let nextButton;
  let currentCounter;
  let totalCounter;

  function initJournalLightbox() {

    lightbox = document.querySelector(SELECTORS.lightbox);

    if (!lightbox) return;

    lightboxImage = lightbox.querySelector(SELECTORS.lightboxImage);
    closeButton = lightbox.querySelector(SELECTORS.close);
    prevButton = lightbox.querySelector(SELECTORS.prev);
    nextButton = lightbox.querySelector(SELECTORS.next);
    currentCounter = lightbox.querySelector(SELECTORS.current);
    totalCounter = lightbox.querySelector(SELECTORS.total);

    buildGallery();

    if (!gallery.length) return;

    bindThumbnailEvents();

    bindLightboxEvents();

    totalCounter.textContent = gallery.length;

  }

  function buildGallery() {

    gallery = [];

    const triggers = document.querySelectorAll(SELECTORS.trigger);

    triggers.forEach((trigger, index) => {

      const image = trigger.querySelector(SELECTORS.image);

      if (!image) return;

      gallery.push({

        trigger,

        image,

        src: image.currentSrc || image.src,

        alt: image.alt || '',

        index

      });

    });

  }

  function bindThumbnailEvents() {

    gallery.forEach(item => {

      item.trigger.addEventListener('click', function (event) {

        event.preventDefault();

        openLightbox(item.index);

      });

    });

  }
  /* ==========================================================
   Part 2 - Open / Close / Render
   ========================================================== */

  function renderImage() {

    const item = gallery[currentIndex];

    if (!item) return;

    lightboxImage.src = item.src;
    lightboxImage.alt = item.alt;

    currentCounter.textContent = currentIndex + 1;

  }

  function openLightbox(index) {

    currentIndex = index;

    renderImage();

    lightbox.classList.add('is-open');

    lightbox.setAttribute('aria-hidden', 'false');

    document.body.classList.add('nd-lightbox-open');

  }

  function closeLightbox() {

    lightbox.classList.remove('is-open');

    lightbox.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('nd-lightbox-open');

  }

  function nextImage() {

    currentIndex++;

    if (currentIndex >= gallery.length) {
      currentIndex = 0;
    }

    renderImage();

  }

  function previousImage() {

    currentIndex--;

    if (currentIndex < 0) {
      currentIndex = gallery.length - 1;
    }

    renderImage();

  }
  /* ==========================================================
   Part 3 - Event Binding & Initialization
   ========================================================== */

  function bindLightboxEvents() {

    closeButton.addEventListener('click', closeLightbox);

    nextButton.addEventListener('click', nextImage);

    prevButton.addEventListener('click', previousImage);

    lightbox.addEventListener('click', function(event) {

      if (event.target === lightbox) {

        closeLightbox();

      }

    });

    document.addEventListener('keydown', function(event) {

      if (!lightbox.classList.contains('is-open')) return;

      switch(event.key) {

        case 'Escape':
          closeLightbox();
          break;

        case 'ArrowRight':
          nextImage();
          break;

        case 'ArrowLeft':
          previousImage();
          break;

      }

    });

  }

  document.addEventListener('DOMContentLoaded', initJournalLightbox);

  document.addEventListener('shopify:section:load', function() {

    buildGallery();

  });

})();